'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNotificationsHub = require('@cimpress-technology/react-notifications-hub');

var _reactComponents = require('@cimpress/react-components');

var _reactI18next = require('react-i18next');

var _i18n = require('../../tools/i18n');

var _helper = require('../../tools/helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubscriptionModal = function (_React$Component) {
    _inherits(SubscriptionModal, _React$Component);

    function SubscriptionModal(props) {
        _classCallCheck(this, SubscriptionModal);

        var _this = _possibleConstructorReturn(this, (SubscriptionModal.__proto__ || Object.getPrototypeOf(SubscriptionModal)).call(this, props));

        _this.state = {
            error: false,
            isUserSubscribed: false,
            subscriptionsForUser: undefined
        };
        _this.onSubscribe = _this.onSubscribe.bind(_this);
        _this.onUnsubscribe = _this.onUnsubscribe.bind(_this);
        _this.onCloseModal = _this.onCloseModal.bind(_this);
        _this.init = _this.init.bind(_this);
        return _this;
    }

    _createClass(SubscriptionModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.init();
        }
    }, {
        key: 'init',
        value: function init() {
            var _this2 = this;

            var user = (0, _helper.getCanonicalIdFromJWT)(this.props.accessToken);
            this.props.getSubscriptions({ resourceType: _helper.COMMENT_RESOURCE, resourceId: this.props.commentUri }).then(function (rawSubscriptions) {
                var subscriptionForUser = rawSubscriptions.find(function (sub) {
                    return sub.subscriber === user;
                });
                if (subscriptionForUser) {
                    _this2.setState({ isUserSubscribed: true, subscriptionsForUser: subscriptionForUser });
                } else {
                    _this2.setState({ isUserSubscribed: undefined, subscriptionsForUser: undefined });
                }
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.show !== prevProps.show) {
                this.init();
            }
        }
    }, {
        key: 'onUnsubscribe',
        value: function onUnsubscribe() {
            var _this3 = this;

            this.props.deleteSubscription(this.state.subscriptionsForUser.id).then(function () {
                _this3.onCloseModal();
            });
        }
    }, {
        key: 'onSubscribe',
        value: function onSubscribe() {
            var _this4 = this;

            var subscription = {
                resourceId: this.props.commentUri,
                resourceType: _helper.COMMENT_RESOURCE,
                alertInfo: {
                    channel: 'email'
                },
                _links: {
                    commentResourceUrl: {
                        href: this.props.commentUri
                    }
                }
            };
            return this.props.postSubscription(subscription).then(function () {
                _this4.onCloseModal();
            }).catch(function (err) {
                return _this4.setState({ error: err });
            });
        }
    }, {
        key: 'onCloseModal',
        value: function onCloseModal() {
            this.props.onClose();
        }
    }, {
        key: 'tt',
        value: function tt(key) {
            // eslint-disable-next-line react/prop-types
            var _props = this.props,
                t = _props.t,
                locale = _props.locale;

            if (locale.length > 2) {
                locale = locale.substr(0, 2);
            }
            return t(key, { lng: locale });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactComponents.Modal,
                {
                    show: this.props.show,
                    onRequestHide: this.onCloseModal,
                    closeButton: true,
                    title: this.props.modalTitle || this.tt('modalTitle'),
                    footer: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        _react2.default.createElement(
                            _reactComponents.Button,
                            { onClick: this.onCloseModal },
                            this.tt('cancel')
                        ),
                        _react2.default.createElement(
                            _reactComponents.Button,
                            { variant: 'primary', onClick: this.state.isUserSubscribed ? this.onUnsubscribe : this.onSubscribe },
                            this.state.isUserSubscribed ? this.tt('unsubscribe') : this.tt('subscribe')
                        )
                    ) },
                this.state.error && _react2.default.createElement(
                    'div',
                    null,
                    this.state.error.toString()
                ),
                this.state.isUserSubscribed ? this.props.unsubscriptionModalMessage || this.tt('unsubscriptionModalMessage') : this.props.subscriptionModalMessage || this.tt('subscriptionModalMessage')
            );
        }
    }]);

    return SubscriptionModal;
}(_react2.default.Component);

SubscriptionModal.propTypes = {
    resourceType: _propTypes2.default.string.isRequired, // subscription resource type
    modalTitle: _propTypes2.default.string.isRequired,
    subscriptionModalMessage: _propTypes2.default.string.isRequired,
    unsubscriptionModalMessage: _propTypes2.default.string.isRequired,
    show: _propTypes2.default.bool,
    onClose: _propTypes2.default.func,
    postSubscription: _propTypes2.default.func.isRequired,
    getSubscriptions: _propTypes2.default.func.isRequired,
    accessToken: _propTypes2.default.string.isRequired,
    deleteSubscription: _propTypes2.default.func.isRequired,
    commentUri: _propTypes2.default.string,
    locale: _propTypes2.default.any
};

SubscriptionModal.defaultProps = {
    locale: 'en'
};

exports.default = (0, _reactI18next.translate)('translations', { i18n: (0, _i18n.getI18nInstance)() })((0, _reactNotificationsHub.withSubscriptionsManagement)(SubscriptionModal));